import {
  CREATECHANNELPARTNERSETUP,
  GETCHANNELPARTNERSETUP,
  UPDATECHANNELPARTNERSETUP,
  DELETECHANNELPARTNERSETUP,
    GET_CHANNEL_PARTNER_SOURCE,
  CREATE_CHANNEL_PARTNER_SOURCE,
  UPDATE_CHANNEL_PARTNER_SOURCE,
  DELETE_CHANNEL_PARTNER_SOURCE,
  GETCHANNELPARTNERSETUPWITHNULL, 
  GETCHANNELPARTNERSETUPWITHOUTNULL,
  axios,
  baseURL,
} from "./types";

const makeApiRequest = (config, dispatch, type) => {
  return new Promise((resolve, reject) => {
    axios(config)
      .then((response) => {
        if (dispatch && type) {
          dispatch({
            type: type,
            payload: response.data,
          });
        }
        resolve(response.data);
      })
      .catch((error) => {
        console.error(`API Error for ${config.url}:`, error);
        reject(error);
      });
  });
};
export const createChannelPartnerSetup = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/channelpartnercommission/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, CREATECHANNELPARTNERSETUP);
};

export const getChannelPartnerSetup = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/channelpartnercommission/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, GETCHANNELPARTNERSETUP);
};

export const updateChannelPartnerSetup = (data) => (dispatch) => {
  const config = {
    method: "patch",
    url: baseURL + "/api/channelpartnercommission/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, UPDATECHANNELPARTNERSETUP);
};

export const deleteChannelPartnerSetup = (data) => (dispatch) => {
  const config = {
    method: "delete",
    url: baseURL + "/api/channelpartnercommission/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return new Promise((resolve, reject) => {
    axios(config)
      .then((res) => {
        dispatch({
          type: DELETECHANNELPARTNERSETUP,
          payload: res.data,
          channelPartnerId: data.id,
        });
        resolve(res.data);
      })
      .catch((err) => reject(err));
  });
};


export const getChannelPartnerSource = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupsourcetype/getall", 
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, GET_CHANNEL_PARTNER_SOURCE);
};


export const createChannelPartnerSource = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupsourcetype/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, CREATE_CHANNEL_PARTNER_SOURCE);
};


export const updateChannelPartnerSource = (data) => (dispatch) => {
  const config = {
    method: "patch",
    url: baseURL + "/api/setupsourcetype/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, UPDATE_CHANNEL_PARTNER_SOURCE);
};

export const deleteChannelPartnerSource = (data) => (dispatch) => {
  const config = {
    method: "delete",
    url: baseURL + "/api/setupsourcetype/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((res) => {
        dispatch({
          type: DELETE_CHANNEL_PARTNER_SOURCE,
          payload: res.data,
          sourceId: data.id, 
        });
        resolve(res.data);
      })
      .catch((err) => reject(err));
  });
};
export const getChannelPartnerSetupWithNull = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/channelpartnercommission/getall-setup",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, GETCHANNELPARTNERSETUPWITHNULL);
};

export const getChannelPartnerSetupWithoutNull = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/channelpartnercommission/getall-partner",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, GETCHANNELPARTNERSETUPWITHOUTNULL);
};